import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    padding: 0 ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }
`;

export const Container = styled.div`
    margin-top: ${rem(45)};
`;

export const Title = styled.h2`
    font-size: ${({ theme }) => theme.fontSizes.h5};
    text-align: center;
    color: ${({ theme }) => theme.colors.primary};
`;

export const Link = styled.a`
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    text-decoration: underline;
    display: inline-block;
`;

export const Description = styled.p`
    line-height: ${rem(24)};
    display: flex;
    gap: ${rem(25)};
`;

export const Label = styled.span<{ bottom?: number }>`
    display: block;
    padding-bottom: ${(prop) => (prop.bottom ? rem(prop.bottom) : 0)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    text-align: center;
`;

export const SectionNumber = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    display: block;
`;

export const Bold = styled.strong``;
